import { render } from "./TopQueuesCard.vue?vue&type=template&id=168a10f6"
import script from "./TopQueuesCard.vue?vue&type=script&lang=js"
export * from "./TopQueuesCard.vue?vue&type=script&lang=js"

import "./TopQueuesCard.vue?vue&type=style&index=0&id=168a10f6&lang=css"
script.render = render

export default script